<section class="new-howitworks how-works-section">
  <div class="container-fluid">
    <div class="mb-5">
      <h2 class="site-title title-fonts text-center">How It Works</h2>
      <div class="text-center">
        <img src="{{ assetURL }}/assets/images/title-decor.svg" width="100%" height="100%"  class="img-decor-top" alt="247Invites">
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-lg card-section" >
        <div class="img-card-box">
          <div class="img-aligned-box">
            <img src="{{ assetURL }}/assets/images/select-invite.svg" width="100%" height="100%" class="img-fluid" alt="247Invites">
          </div>
          <h5>Select Invite</h5>
          <p>Select template from 1000+ beautiful designs</p>
        </div>
      </div>
      <div class="col-1 col-lg-auto mx-auto d-flex align-items-center" >
        <img src="{{ assetURL }}/assets/images/arrow-r.svg" width="100%" height="100%"  class="arrow d-none d-lg-flex" alt="247Invites">
        <img src="{{ assetURL }}/assets/images/arrow-b.svg" width="100%" height="100%"  class="arrow_bottom d-flex d-lg-none" alt="247Invites">
      </div>
      <div class="col-lg card-section">
        <div class="img-card-box">
          <div class="img-aligned-box">
            <img src="{{ assetURL }}/assets/images/fill-details.svg" width="100%" height="100%"  class="img-fluid" alt="247Invites">
          </div>
          <h5>Fill Details</h5>
          <p>Fill text, add photos and audios</p>
        </div>
      </div>
      <div class="col-1 col-lg-auto mx-auto d-flex align-items-center">
        <img src="{{ assetURL }}/assets/images/arrow-r.svg" width="100%" height="100%"  class="arrow d-none d-lg-flex" alt="247Invites">
        <img src="{{ assetURL }}/assets/images/arrow-b-l.svg" width="100%" height="100%"  class="arrow_bottom d-flex d-lg-none" alt="247Invites">
      </div>
      <div class="col-lg card-section card-section-last">
        <div class="img-card-box">
          <div class="img-aligned-box">
            <img src="{{ assetURL }}/assets/images/download-icon.svg" width="100%" height="100%"  class="img-fluid" alt="247Invites">
          </div>
          <h5>Download</h5>
          <p>Share and Download your Invitation easily</p>
        </div>
      </div>
    </div>
    <div class="row mt-5 justify-content-center">
      <div class="col-md-auto col-8" >
        <button type="button" (click)="HowWorks()" class="btn-247 w-100 btn-primary-outline-main btn-large">
          <span class="mr-2">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9 18.4707C10.1819 18.4707 11.3522 18.2379 12.4442 17.7856C13.5361 17.3333 14.5282 16.6704 15.364 15.8347C16.1997 14.9989 16.8626 14.0068 17.3149 12.9149C17.7672 11.8229 18 10.6526 18 9.4707C18 8.28881 17.7672 7.11848 17.3149 6.02655C16.8626 4.93462 16.1997 3.94247 15.364 3.10674C14.5282 2.27101 13.5361 1.60808 12.4442 1.15579C11.3522 0.703495 10.1819 0.470703 9 0.470703C6.61305 0.470703 4.32387 1.41891 2.63604 3.10674C0.948212 4.79457 0 7.08375 0 9.4707C0 11.8577 0.948212 14.1468 2.63604 15.8347C4.32387 17.5225 6.61305 18.4707 9 18.4707ZM7.783 5.4607L13.427 8.5967C13.5828 8.68333 13.7126 8.81005 13.803 8.96371C13.8934 9.11738 13.9411 9.29242 13.9411 9.4707C13.9411 9.64898 13.8934 9.82402 13.803 9.97769C13.7126 10.1314 13.5828 10.2581 13.427 10.3447L7.783 13.4807C7.60025 13.5823 7.39413 13.6344 7.18506 13.6317C6.97599 13.6291 6.77123 13.572 6.59107 13.4659C6.4109 13.3598 6.26159 13.2084 6.15791 13.0269C6.05424 12.8453 5.9998 12.6398 6 12.4307V6.5107C5.9998 6.30162 6.05424 6.09611 6.15791 5.91454C6.26159 5.73297 6.4109 5.58164 6.59107 5.47554C6.77123 5.36944 6.97599 5.31226 7.18506 5.30966C7.39413 5.30705 7.60025 5.35912 7.783 5.4607Z"
                  />
            </svg>
          </span>
          Watch video
        </button>
      </div>
    </div>
  </div>
</section>